import styled from 'styled-components';

export const StyledAddressMap = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: var(--r-md);
  overflow: hidden;
  border: 1px solid var(--line);
  position: relative;
  background: var(--paper-2);

  .maplibregl-canvas { outline: none; }

  .maplibregl-ctrl-group {
    border-radius: var(--r-sm);
    overflow: hidden;
    box-shadow: var(--sh-1);
    border: 1px solid var(--line);
    background: var(--surface);
  }
  .maplibregl-ctrl-group button {
    width: 28px;
    height: 28px;
  }
  .maplibregl-ctrl-group button + button { border-top: 1px solid var(--line); }

  .maplibregl-ctrl-attrib {
    font-size: 10px;
    background: color-mix(in srgb, var(--surface) 78%, transparent);
  }
  .maplibregl-ctrl-attrib a { color: var(--muted); }
`;

export const StyledMapsLink = styled.a`
  position: absolute;
  top: 8px;
  inset-inline-start: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 9px;
  border-radius: var(--r-full);
  background: var(--surface);
  border: 1px solid var(--line);
  box-shadow: var(--sh-1);
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);
  text-decoration: none;

  &:hover { color: var(--ink); }
`;

export const StyledApproxNote = styled.div`
  position: absolute;
  bottom: 8px;
  inset-inline-start: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: var(--r-full);
  background: color-mix(in srgb, var(--surface) 88%, transparent);
  backdrop-filter: blur(4px);
  border: 1px solid var(--line);
  box-shadow: var(--sh-1);
  font-size: 11px;
  font-weight: 600;
  color: var(--muted);

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--brand-ink);
    opacity: 0.55;
  }
`;
